import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  widthAuto: {
    width: "auto",
  },
  mr12: {
    marginRight: "12px",
  },
  totalPriceContainer: {
    marginTop: "16px",
    borderRadius: "8px",
  },
  totalPriceTitle: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 14,
    color: "#465869",
    lineHeigth: 21,
  },
  gap4: {
    gap: "4px",
  },
  mr16: {
    marginRight: "16px",
  },
  totalPriceSymbolValue: {},
  totalPriceSymbol: {
    ...getTextProperties("16px"),
    lineHeigth: 24,
  },
  totalPriceValue: {
    ...getTextProperties("16px"),
    fontWeight: 500,
    textAlign: "end",
  },
}));

export default styles;

const getTextProperties = (fontSize: string) => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize,
  color: "#465869",
});
